import { DeliveryOrdersResponse } from '@diamond/shared/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { getDeliveryOrders } from '../queries/order';
import { useAuthStore } from '../stores';

export function getDeliveryOrdersOptions(
  accessToken: string,
  orderMetaId: string,
  warehouse: string,
  shouldRunQuery = true
) {
  const runQuery =
    typeof orderMetaId === 'string' &&
    typeof warehouse === 'string' &&
    shouldRunQuery;

  return queryOptions<DeliveryOrdersResponse>({
    queryKey: ['DeliveryOrders', orderMetaId, warehouse],
    queryFn: () => getDeliveryOrders(accessToken, orderMetaId, warehouse),
    enabled: runQuery,
  });
}

export const useGetDeliveryOrders = (
  orderMetaId: string,
  warehouse: string,
  shouldRunQuery = true
) => {
  const session = useAuthStore();

  return useQuery(
    getDeliveryOrdersOptions(
      session.access_token,
      orderMetaId,
      warehouse,
      shouldRunQuery
    )
  );
};
